import {
  Spotlight,
  SpotlightActionData,
  SpotlightActionGroupData,
  spotlight,
} from '@mantine/spotlight';
import '@mantine/spotlight/styles.css';

import classes from './Spotlight.module.css';

const SpotlightDefaults = Spotlight.extend({
  classNames: {
    body: classes.body,
    action: classes.action,
    actionsGroup: classes.actionsGroup,
    search: classes.search,
  },
});

export { Spotlight, SpotlightDefaults, spotlight };
export type { SpotlightActionData, SpotlightActionGroupData };
